import VueRouter from "vue-router";
import heatRoutes from "heat-shared/src/routes";
import Vue from "vue";
import urls from '../urls'
import * as guards from "./guards";

//Dynamic imports don't actually save that much size, but can add load times
import HomePage from "../pages/HomePage";
import Viewer from "../pages/LiveView";
import Wrapper from "../pages/Info/Wrapper";
import Overview from "../pages/Info/Edar/Overview";
import Detail from "../pages/Info/Edar/Detail";
import Staff from "../pages/Info/Staff";
import StaffLiveView from "../pages/Info/Edar/StaffLiveView";
import DeploymentOverview from "../pages/Info/Deployment/DeploymentOverview";
import DeploymentDetail from "../pages/Info/Deployment/DeploymentDetail";

Vue.use(VueRouter);

const DummyComponent = Vue.component('dummy', {
    template: '<router-view></router-view>'
});

const router = new VueRouter({
    mode: 'history',
    // linkExactActiveClass: 'is-active',
    routes: [
        {
            path: '/',
            name: 'home',
            component: HomePage,
            alias: '/login',
            meta: {
                title: 'HEAT Live Viewer',
            }
        },
        {
            path: urls.admin_site,
            name: 'admin-site',
            beforeEnter() {
                location.href = '/admin/'
            }
        },
        {
            path: '/viewer/:edarId',
            name: 'viewer',
            component: Viewer,
            props: true,
            meta: {
                title: 'Edar Live View',
                requires: ['edar'],
                permission: 'user',
            }
        },
        {
            path: '/monitor/',
            component: Wrapper,
            meta: {
                title: 'EDAR Status Monitor',
                breadcrumb: 'Status Monitor',
                requires: ['edar', 'deployment'],
            },
            children: [
                {
                    path: '',
                    name: 'staff_home',
                    component: Staff,
                    meta: {
                        permission: 'staff'
                    },
                },
                {
                    path: 'edar/',
                    component: DummyComponent,
                    meta: {
                        breadcrumb: 'Edar',
                        permission: 'staff'
                    },
                    children: [
                        {
                            path: '',
                            name: 'edar_overview',
                            component: Overview,
                            meta: {
                                title: 'EDAR Status Overview',
                                permission: 'staff'
                            },
                        },
                        {
                            path: ':edarId',
                            name: 'edar_detail',
                            props: true,
                            component: Detail,
                            meta: {
                                title: 'EDAR Details',
                                permission: 'staff',
                                breadcrumb: 'EDAR Details',
                            }
                        },
                        {
                            path: ':edarId/viewer',
                            name: 'edar_staff_viewer',
                            props: true,
                            component: StaffLiveView,
                            meta: {
                                title: 'EDAR Viewer (Staff)',
                                permission: 'staff',
                                breadcrumb: 'Viewer',
                            }
                        },
                    ],
                },
                {
                    path: 'deployment/',
                    component: DummyComponent,
                    meta: {
                        breadcrumb: 'Deployment',
                        permission: 'staff',
                    },
                    children: [
                        {
                            path: '',
                            name: 'deployment_overview',
                            component: DeploymentOverview,
                            meta: {
                                title: 'Deployment Statistics Overview',
                                permission: 'staff'
                            },
                        },
                        {
                            path: ':deploymentId',
                            name: 'deployment_detail',
                            props: true,
                            component: DeploymentDetail,
                            meta: {
                                title: 'Deployment Details',
                                permission: 'staff',
                                breadcrumb: 'Deployment Details',
                            }
                        },
                    ],
                },
            ],
        },
        ...heatRoutes,
    ],
});

router.beforeEach(guards.firstTimeGuard);
router.beforeEach(guards.permissionsGuard);
router.beforeEach(guards.setTitleGuard);

export default router;
